'use strict';

const dictionary = {
  lrd: {
    docType: 'Scientific Response Document',
    viewLink: 'View Document',
  },
  conference_material: {
    docType: 'Conference Material(s)',
    viewLink: 'View Material',
  },
  publication: {
    docType: 'Publication',
    viewLink: 'View Publication',
  },
};

/*
 * View of results
 */
class Results {

  /*
   * Create results object on item with 'selector',
   * give result links linkClasses when creating.
   */
  constructor(selector, linkClasses) {
    this.list  = document.querySelector(selector);

    this.classes = linkClasses;
  }

  /*
   * Clear all results
   */
  reset() {
    this.list.innerHTML = '';
  }

  /*
   * Reset results and populate with given html
   */
  set(html) {
    this.reset();
    this.list.innerHTML = html;
  }

  /*
   * Returns date in "Month Day, Year" format
   */
  parseDate(json) {
    let date = new Date(json);
    const month = date.toLocaleString('default', { month: 'long', timeZone: 'UTC' });
    const year = date.getUTCFullYear();
    const day = date.getUTCDate();

    date = `${month} ${day}, ${year}`;

    return date;
  }

  /*
   * Creates and returns search result html component
   */
  /* eslint-disable */
  entry(doc, isFilterable = false) {
    // console.log(doc);

    const {
      es_doc_type,
      name,
      title,
      conference_title,
      published_date,
      authors,
      products,
      therapeutic_area,
      indications,
      phase,
      files,
      url,
      path,
    } = doc;
    const [firstAuthor, ...restAuthors] = authors && authors.raw.length
      ? authors.raw
      : [];

    const html = `
      <div
        class="entry ${isFilterable ? 'js-filterable-item' : ''}"
        ${phase ? `data-phase="${phase.raw}"` : ''}
      >
        <div class="entry__type">
          ${dictionary[es_doc_type.raw].docType}
        </div>
        ${name || title || conference_title
          ? `<h3 class="entry__title">
              ${name ? name.raw : title ? title.raw : conference_title.raw}
            </h3>`
          : ''
        }
        <ul class="entry__meta">
          ${published_date
            ? `<li><strong>Published:</strong> ${this.parseDate(published_date.raw)}</li>`
            : ''
          }
          ${authors && authors.raw.length
            ? `<li>
                <strong>Author(s):</strong> ${firstAuthor}
                ${restAuthors.length
                  ? `(+${restAuthors.length} more)`
                  : ''
                }
              </li>`
            : ''
          }
        </ul>
        <ul class="entry__tags">
          ${products && products.raw.length
            ? products.raw.map(product => `<li class="entry__product">${product}</li>`).join('')
            : ''
          }
          ${therapeutic_area && therapeutic_area.raw.length
            ? therapeutic_area.raw.map(ta => `<li>${ta}</li>`).join('')
            : ''
          }
          ${indications && indications.raw.length
            ? indications.raw.map(indication => `<li>${indication}</li>`).join('')
            : ''
          }
          ${phase
            ? `<li>${phase.raw}</li>`
            : ''
          }
        </ul>
        ${es_doc_type.raw === 'lrd'
          ? `<ul class="entry__links">
              <li>
                <a
                  class="btn btn-link"
                  href="/docs/${path.raw}"
                >${dictionary[es_doc_type.raw].viewLink}</a>
              </li>
            </ul>`
          : ''
        }
        ${es_doc_type.raw === 'publication'
          ? `<ul class="entry__links">
              <li>
                <a
                  class="btn btn-link js-modal-trigger"
                  href="${url.raw}"
                  data-modal="leave"
                >${dictionary[es_doc_type.raw].viewLink}</a>
              </li>
            </ul>`
          : ''
        }
        ${es_doc_type.raw === 'conference_material' && files && files.raw.length
          ? `<ul class="entry__links">
              ${files.raw.map(file => {
                file = JSON.parse(file);
                let matUrl = file.file;

                if (!matUrl.startsWith('docs')) {
                  matUrl = matUrl.replace(
                    window.projectGlobals.S3_PATH_BASE + 'conferences/',
                    ''
                  );
                  matUrl = matUrl.replace('/docs/conference/', '');
                  matUrl = `/docs/conference/${matUrl}`;
                }

                return `
                  <li>
                    <a
                      class="btn btn-link"
                      href="${matUrl}"
                      target="_blank"
                    >View ${file.hasOwnProperty('media_type') ? file.media_type : 'Material'}</a>
                  </li>
                `
              }).join('')}
            </ul>`
          : ''
        }
      </div>
    `;

    return html;
  }
  /* eslint-enable */
}


export default Results;



// WEBPACK FOOTER //
// ./src/assets/js/project/search/results.js